import { render, staticRenderFns } from "./RiAppBordereaux.vue?vue&type=template&id=1c40df0e&"
import script from "./RiAppBordereaux.vue?vue&type=script&lang=js&"
export * from "./RiAppBordereaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports